import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../config/constants';
import { importTemplteFn } from '../../transactions/download/download';
import { size } from 'lodash';

const { IMPORT_TEMPLATE } = QUERY_KEYS;

export const useImportTemplate = (field = '') => {
  return useQuery({
    queryKey: [IMPORT_TEMPLATE, field],
    queryFn: () => importTemplteFn(field),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: false,
    onSuccess: (data) => {
      // error handler
      //  toast('Success');
      if (data.exceptions) {
        if (size(data.exceptions) > 0) {
          return;
        }
      }
      const url = window.URL.createObjectURL(
        new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'importDriversTemplate.xlsx');
      document.body.appendChild(link);
      link.click();
    },
  });
};
